import { Button } from '@/components/ui/button'
import type { Association } from '@/pages/StaffSignInPage'

export function Confirmation({ association }: { association: Association }) {
  return (
    <main className="flex min-h-screen items-center bg-background px-6 py-6 text-foreground">
      <section className="mx-auto w-full max-w-xl space-y-4 rounded-md border border-border bg-card p-6">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-success/15 text-success">
          ✓
        </div>
        <h1 className="text-subheading font-semibold">Thank you for your gift</h1>
        <p className="text-body-sm text-muted-foreground">
          Your gift to {association.name} was received. A receipt will be sent to your email.
        </p>
        <Button asChild variant="outline">
          <a href="/give">Make another gift</a>
        </Button>
      </section>
    </main>
  )
}
